import { render } from "./AddNotificationRedevancePage.vue?vue&type=template&id=b1e7d19a&ts=true"
import script from "./AddNotificationRedevancePage.vue?vue&type=script&lang=ts"
export * from "./AddNotificationRedevancePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__